import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../../utils/app-settings';
import { MobileCalendarModel } from '../../models/mobile-calendar-model';
import { ReplaySubject } from 'rxjs';
import { DateUtils } from '../../../../../utils/date-utils';
import { DatePipe } from '@angular/common';
import { DatewiseEvents } from '../../models/datewise-events';

@Injectable({
  providedIn: 'root'
})
export class MobileEventsService {

  constructor(private http: HttpClient
    , private datepipe: DatePipe) { }

  private months: Array<MobileCalendarModel> = [];
  private _months: ReplaySubject<MobileCalendarModel> = new ReplaySubject<MobileCalendarModel>(1);
  public months$ = this._months.asObservable();
  private items_per_view = 42;
  private emitted: boolean;
  private current_date: Date;

  getEventsForMonth(curr_month_start_date: Date) {
    this.current_date = curr_month_start_date;
    let prev_month_start_date: Date = new Date(curr_month_start_date);
    prev_month_start_date.setMonth(prev_month_start_date.getMonth() - 1);
    let next_month_start_date: Date = new Date(curr_month_start_date);
    next_month_start_date.setMonth(next_month_start_date.getMonth() + 1);

    let curr_month = this.months.find(o => o.month == curr_month_start_date.getMonth() && o.year == curr_month_start_date.getFullYear());
    let prev_month = this.months.find(o => o.month == prev_month_start_date.getMonth() && o.year == prev_month_start_date.getFullYear());
    let next_month = this.months.find(o => o.month == next_month_start_date.getMonth() && o.year == next_month_start_date.getFullYear());

    if (curr_month) {
      this._months.next(curr_month);
      this.emitted = true;
    }
    let cal_view_start_date: Date;
    let cal_view_end_date: Date;
    let start_dates: Array<Date> = [];
    if (!prev_month || !curr_month || !next_month) {
      if (prev_month && curr_month) {
        cal_view_start_date = DateUtils.getStartDateForMonthView(next_month_start_date);
        cal_view_end_date = new Date(cal_view_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(next_month_start_date);
      }
      else if (curr_month && next_month) {
        cal_view_start_date = DateUtils.getStartDateForMonthView(prev_month_start_date);
        cal_view_end_date = new Date(cal_view_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(prev_month_start_date);
      }
      else if (prev_month && next_month) {
        cal_view_start_date = DateUtils.getStartDateForMonthView(curr_month_start_date);
        cal_view_end_date = new Date(cal_view_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(curr_month_start_date);
      }
      else if (prev_month) {
        cal_view_start_date = DateUtils.getStartDateForMonthView(curr_month_start_date);
        cal_view_end_date = DateUtils.getStartDateForMonthView(next_month_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(curr_month_start_date);
        start_dates.push(next_month_start_date);
      }
      else if (next_month) {
        cal_view_start_date = DateUtils.getStartDateForMonthView(prev_month_start_date);
        cal_view_end_date = DateUtils.getStartDateForMonthView(curr_month_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(prev_month_start_date);
        start_dates.push(curr_month_start_date);
      }
      else {
        cal_view_start_date = DateUtils.getStartDateForMonthView(prev_month_start_date);
        cal_view_end_date = DateUtils.getStartDateForMonthView(next_month_start_date);
        cal_view_end_date.setDate(cal_view_end_date.getDate() + (this.items_per_view - 1));
        start_dates.push(prev_month_start_date);
        start_dates.push(curr_month_start_date);
        start_dates.push(next_month_start_date);
      }
      this.getEventsForCalendar(cal_view_start_date, cal_view_end_date, start_dates);
    }
  }

  private getEventsForCalendar(start_date: Date, end_date: Date, start_dates: Array<Date>) {
    let strStartDate = this.datepipe.transform(start_date, "yyyy-MM-dd");
    let strEndDate = this.datepipe.transform(end_date, "yyyy-MM-dd");
    this.http.get<Array<DatewiseEvents>>(AppSettings.apiUrl + "events/GetByDateRange?startDate=" + strStartDate + "&endDate=" + strEndDate)
      .subscribe(res => {
        start_dates.forEach(date => {
          let month = new MobileCalendarModel();
          month.month = date.getMonth();
          month.year = date.getFullYear();
          month.event_days = [];
          let events = res.filter(o => {
            let date = DateUtils.parseDateAndTime(o.event_date);
            return (date > month.calendar_view_start_date || date.getTime() == month.calendar_view_start_date.getTime())
              && (date < month.calendar_view_end_date || date.getTime() == month.calendar_view_end_date.getTime());
          }
          );
          month.event_days.push(...events);
          this.months.push(month);
        });
        if (!this.emitted) {
          let curr_month = this.months.find(o => o.month == this.current_date.getMonth() && o.year == this.current_date.getFullYear());
          this._months.next(curr_month);
          this.emitted = false;
        }
      });
  }
}
